import { render, staticRenderFns } from "./PODetailSection.vue?vue&type=template&id=9adcbba2"
import script from "./PODetailSection.vue?vue&type=script&lang=js"
export * from "./PODetailSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports